class CegoXMPPTime {

    getTimestamp() {
        return Math.round(app.util.getTime() / 1000);
    }

    readableTime(timestamp) {
        const time = (!timestamp) ? new Date() : new Date(timestamp * 1000);
        let hours = time.getHours();
        let minutes = time.getMinutes();

        hours = (hours < 10) ? '0' + hours : hours;
        minutes = (minutes < 10) ? '0' + minutes : minutes;

        return hours + ':' + minutes;
    }

    timeAgo(language, timestamp) {
        if (isNaN(timestamp)) {
            return;
        }
        if (timestamp > 9999999999) {
            timestamp = parseInt(timestamp.toString().substr(0, 10));
        }
        let now = this.getTimestamp();
        if (now > 9999999999) {
            now = parseInt(now.toString().substr(0, 10));
        }
        let delta = now - timestamp;
        delta = (delta < 2) ? 2 : delta;
        let r = '';
        if (delta < 60) {
            r = language.rightNow;
            // r = delta + ' sekunder siden';
        } else if (delta < 120) {
            r = language.aMinuteAgo;
        } else if (delta < (60 * 60)) {
            r = language.minutesAgo.replace('XX', (parseInt(delta / 60, 10)).toString());
        } else if (delta < (2 * 60 * 60)) {
            r = language.anHourAgo;
        } else if (delta < (24 * 60 * 60)) {
            r = language.hoursAgo.replace('XX', (parseInt(delta / 3600, 10)).toString());
        } else if (delta < (48 * 60 * 60)) {
            r = language.yesterday + ' ' + language.at + ' ' + this.readableTime(timestamp);
        } else if (delta < (72 * 60 * 60)) {
            r = language.daysAgo.replace('XX', (parseInt(delta / 86400, 10)).toString()) + ' ' + language.at + ' ' + this.readableTime(timestamp);
        } else {
            r = language.daysAgo.replace('XX', (parseInt(delta / 86400, 10)).toString()) + ' ';
        }

        return r;
    }

    smartTime(language, timestamp) {
        let delta = parseInt((this.getTimestamp() - timestamp), 10);
        delta = (delta < 2) ? 2 : delta;

        /* Today */
        const date = new Date(timestamp * 1000);
        if (date.toDateString() == (new Date()).toDateString()) {
            return this.readableTime(timestamp);
        } else {
            return this.timeAgo(language, timestamp);
        }
    }
}